import { render, staticRenderFns } from "./Cheng.vue?vue&type=template&id=baf16d62&scoped=true"
import script from "./Cheng.vue?vue&type=script&lang=js"
export * from "./Cheng.vue?vue&type=script&lang=js"
import style0 from "./Cheng.vue?vue&type=style&index=0&id=baf16d62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf16d62",
  null
  
)

export default component.exports